import React, { createContext, useContext, useState } from "react";

// Create the context
const SelectedCharacterContext = createContext();

// Create a provider component
export const SelectedCharacterProvider = ({ children }) => {
  const [selectedCharacter, setSelectedCharacter] = useState(null);

  return (
    <SelectedCharacterContext.Provider
      value={{ selectedCharacter, setSelectedCharacter }}
    >
      {children}
    </SelectedCharacterContext.Provider>
  );
};

// Custom hook to use the SelectedCharacterContext
export const useSelectedCharacter = () => {
  return useContext(SelectedCharacterContext);
};
